import React from 'react';
import {connect} from './../../../base/redux';
import './loader.css';

const Loader = (props) => {
    const {loader} = props;
    return (
        <div id="preloader" className={`${loader?"show":"hide"}`}>
            <div id="loader">
            </div>
        </div>
    )
}
const mapStateToProps = state => ({
	loader: state['features/nxatel'].loader
});

export default connect(mapStateToProps)(Loader);